import {Tabs} from "antd";
import styled from "styled-components";

export const DateRangePickerWrapper = styled.div`
    position: relative;
    @media (max-width: 768px) {
        width: 100%;
        .ant-picker {
            width: 100%;
            max-width: 100%;
            min-width: 0;
        }
        .ant-picker-input > input {
            min-width: 0;
            font-size: 13px;
        }
        /* Takvim dropdown wrapper içinde render edilir; sayfaya sığsın */
        .ant-picker-dropdown {
            position: absolute !important;
            left: 0 !important;
            right: 0 !important;
            max-width: 100% !important;
            width: 100% !important;
            z-index: 1050;
        }
        .ant-picker-panel-container {
            max-width: 100%;
        }
        .ant-picker-panels {
            flex-direction: column;
            max-width: 100%;
        }
        .ant-picker-panel {
            max-width: 100%;
        }
        .ant-picker-content {
            max-width: 100%;
        }
        .ant-picker-body {
            max-width: 100%;
        }
        /* Takvim hücreleri küçük ekranda sığsın */
        .ant-picker-cell {
            padding: 2px;
        }
        .ant-picker-cell-inner {
            font-size: 12px;
        }
    }
`;

export const TabsContainer = styled(Tabs)`
    @media (max-width: 768px) {
        .ant-tabs-nav {
            .ant-tabs-nav-wrap {
                .ant-tabs-nav-list {
                    display: flex;
                    flex-direction: row;
                }
            }
        }
    }
`;

export const WalletInfoRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
        & > * {
            width: 100%;
        }
        .ant-tag {
            width: 100%;
            text-align: center;
            margin-right: 0;
            padding: 8px 12px;
            line-height: 1.4;
            white-space: normal;
        }
    }
`;

export const ActionButtonWrapper = styled.span`
    display: inline-flex;
    @media (max-width: 768px) {
        min-width: 100%;
        width: 100%;
        & button {
            width: 100%;
            min-width: 140px;
        }
    }
`;
